/**
 * Product tile click tracking for the Intelligems collection tile text test
 * (molecule-collection-product-tile.liquid). Fires in every group, so the
 * test can compare clicks between control and test.
 *
 * Pushes { event: 'product_tile_clicked' } onto window.igEvents when a
 * shopper follows a product tile's link: a plain click, cmd/ctrl/shift-click
 * (all fire `click`) or a middle-click (fires `auxclick` only). Swatch clicks
 * are not links and E-Spots are not product tiles, so neither counts. The
 * Intelligems bundle drains the queue once loaded, so no ig:ready wait is
 * needed. The event must be registered in the Intelligems Events Manager
 * before it can be used as a test metric.
 *
 * One delegated listener per event type on the document, so tiles added
 * later by infinite scroll or re-rendered by the filters are tracked without
 * re-binding.
 */

export const PRODUCT_TILE_CLICK_EVENT = 'product_tile_clicked'
const PRODUCT_TILE_LINK_SELECTOR = '[data-product-tile] a[href]'
const MIDDLE_BUTTON = 1

/**
 * Listen for clicks on product tile links and queue an Intelligems event.
 * @param {Document} doc - Document to listen on
 * @param {Window} win - Window that owns the igEvents queue
 * @returns {() => void} - Removes the listeners
 */
export function trackProductTileClicks(doc = document, win = window) {
  const track = (event) => {
    const target = event.target
    if (!(target instanceof Element)) return
    if (!target.closest(PRODUCT_TILE_LINK_SELECTOR)) return

    win.igEvents = win.igEvents || []
    win.igEvents.push({ event: PRODUCT_TILE_CLICK_EVENT })
  }
  const onAuxClick = (event) => {
    if (event.button === MIDDLE_BUTTON) track(event)
  }
  doc.addEventListener('click', track)
  doc.addEventListener('auxclick', onAuxClick)
  return () => {
    doc.removeEventListener('click', track)
    doc.removeEventListener('auxclick', onAuxClick)
  }
}

trackProductTileClicks()
